<template>
    <div> <a-tabs  @change="tabsChange" >
        <a-tab-pane key="1" tab="批量翻译">
            <TranslateAll ref="TranslateAll"/>
        </a-tab-pane>
        <a-tab-pane key="2" tab="翻译日志">
            <TranslationLog ref="TranslationLog"/>
        </a-tab-pane>
        <a-tab-pane key="4" tab="改写日志">
            <RewriteLogs ref="RewriteLogs"/>
        </a-tab-pane>
        <a-tab-pane key="3" tab="句式管理">
            <Prompt ref="Prompt"/>
        </a-tab-pane>
    </a-tabs></div>
</template>

<script>
    import TranslateAll from "./components/translateAll"
    import TranslationLog from "./components/translationLog"
    import Prompt from "./components/prompt/index.vue"
    import RewriteLogs from "./components/rewritelogs"
    export default {
        name: "index",
        data(){
            return{

            }
        },
        components:{TranslateAll,TranslationLog, Prompt,RewriteLogs},
        created() {
            this.$store.state.adminleftnavnum = "/BatchTranslation/SinglePageList"; //设置左侧导航2-2 active
        },
        methods:{
            tabsChange(data){
                if(data==1){
                    console.log(this.$refs['TranslateAll'].seach)
                    if(this.$refs['TranslateAll'].seach.a_customer_id){
                        this.$refs['TranslateAll'].getList()
                    }
                }else if(data==2){
                    setTimeout(()=>{
                        if(this.$refs['TranslationLog'].seach.a_customer_id){
                            this.$refs['TranslationLog'].getList()
                        }
                    },100)
                }else{
                    setTimeout(()=>{
                        if(this.$refs['RewriteLogs'].seach.a_customer_id){
                            this.$refs['RewriteLogs'].getList()
                        }
                    },100)
                }
            }
        }
    }
</script>

<style scoped>

</style>